import { NotificationType } from 'modules/notifications/types';
import notificationReducer from './notifications';

export type NotificationsState = NotificationType[] | null;

export default notificationReducer;
